module.exports = __webpack_public_path__ + "static/img/Brees-home-bg-lg.4292dee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Brees-home-bg-lg.jpg
// module id = /sY7
// module chunks = 1